import { DividerComponent, PaperComponent } from "@/components";
import {
  CurrencyConverter,
  FormatDateDMY,
  TimeZoneConverter,
  WEB_COLORS,
} from "@/lib/constants";
import { Stack, Typography } from "@mui/material";
import React from "react";

const DetailsCard = ({
  loanNumber,
  appId,
  loanAmount,
  totalEmiCount,
  disbursedDate,
  rateOfInterest,
  loanMaturityDate,
}) => {
  const { formattedDate, formattedTime } = TimeZoneConverter(disbursedDate);
  function DetailField(header, value) {
    return (
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
      >
        <Typography color={WEB_COLORS.textFadeColor}>{header}</Typography>
        <Typography fontWeight={"bold"}>{value}</Typography>
      </Stack>
    );
  }
  return (
    <PaperComponent>
      <Stack gap={2}>
        <Typography variant="h5"> Loan Details</Typography>
        <DividerComponent orientation="horizontal" />
        {DetailField("Loan Number", loanNumber)}
        {DetailField("Loan Application Number", appId)}
        {DetailField("Loan Amount", CurrencyConverter(loanAmount))}
        {DetailField("Loan Tenure", `${totalEmiCount} Months`)}
        {DetailField("Rate Of Interest", rateOfInterest)}
        {/* {DetailField("Annualised Rate of Interest", "23%")} */}
        {DetailField("Loan Disbursed On", `${formattedDate} ${formattedTime}`)}
        {DetailField("Loan Maturity Date", `${loanMaturityDate}`)}
      </Stack>
    </PaperComponent>
  );
};

export default DetailsCard;
